import { render, staticRenderFns } from "./approval-setup.vue?vue&type=template&id=24d85710&"
import script from "./approval-setup.vue?vue&type=script&lang=js&"
export * from "./approval-setup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports